export default __webpack_public_path__ + "static/slider_3-4a701f3490e763510429c6cb26ba35c1.jpg";